// collection-filter-reinit.js
// After an AJAX filter/sort update (collection-filters-form.js) replaces
// [data-products-grid] innerHTML, the [data-aria-toggle] filter button inside
// it is a fresh DOM node that has no event listeners. theme.js S() only runs
// once at DOMContentLoaded and is not re-called. collection-component's own
// MutationObserver is still watching the now-detached old button node.
// This script detects the grid replacement and rebinds the new button.
(function () {

  function rebindFilterButton(grid) {
    var newBtn = grid.querySelector('[data-aria-toggle]');
    if (!newBtn || newBtn._ariaToggleRebound) return;
    newBtn._ariaToggleRebound = true;

    var collComp = grid.closest('collection-component');
    if (!collComp) return;

    // 1. Re-attach collection-component's own click handler (scroll-lock helper).
    //    The reference is stored as a bound arrow fn on the component instance.
    if (typeof collComp.groupTagsButtonClickEvent === 'function') {
      newBtn.addEventListener('click', collComp.groupTagsButtonClickEvent);
    }

    // 2. Re-implement what theme.js S() does: toggle aria-expanded and the
    //    [aria-controls] target's .expanded class (+ transition classes).
    //    Also ensure drawer--animated is added when opening so that freshly
    //    AJAX-injected filter groups (opacity:0 via CSS) animate into view.
    //    showSidebarCallback (called via MutationObserver below) also adds
    //    drawer--animated, but there is a timing edge case after multiple
    //    AJAX updates where it may fire too late for the newly-injected nodes.
    //    Adding it synchronously here in the click handler is the safe fallback.
    newBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var isExpanded = newBtn.getAttribute('aria-expanded') === 'true';
      var isOpening = !isExpanded;
      newBtn.setAttribute('aria-expanded', isOpening ? 'true' : 'false');

      var targetId = newBtn.getAttribute('aria-controls');
      var target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;

      // Ensure drawer--animated is present before expanded toggles so the
      // CSS animation on [data-animation=drawer-items-fade] elements fires
      // for fresh sidebar content (they start at opacity:0).
      if (isOpening) {
        target.classList.add('drawer--animated');
      }

      var onStart = function () {
        target.classList.add('expanding');
        target.removeEventListener('transitionstart', onStart);
      };
      var onEnd = function () {
        target.classList.remove('expanding');
        target.removeEventListener('transitionend', onEnd);
      };
      target.addEventListener('transitionstart', onStart);
      target.addEventListener('transitionend', onEnd);
      target.classList.toggle('expanded');
    });

    // 3. Update collection-component's stale groupTagsButton reference and
    //    re-attach a MutationObserver so showSidebarCallback fires on open.
    collComp.groupTagsButton = newBtn;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type !== 'attributes') return;
        if (newBtn.getAttribute('aria-expanded') === 'true') {
          if (typeof collComp.showSidebarCallback === 'function') {
            collComp.showSidebarCallback();
          }
        }
      });
    }).observe(newBtn, { attributes: true, childList: false, subtree: false });
  }

  function init() {
    var grid = document.querySelector('[data-products-grid]');
    if (!grid || grid._filterReinitBound) return;
    grid._filterReinitBound = true;

    // Only rebind AFTER an AJAX replacement — not on initial load
    // (theme.js S() already handles the button at DOMContentLoaded).
    new MutationObserver(function (mutations) {
      if (!mutations.some(function (m) { return m.addedNodes.length > 0; })) return;
      clearTimeout(grid._rebindTimer);
      grid._rebindTimer = setTimeout(function () {
        rebindFilterButton(grid);
      }, 30);
    }).observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
